import { render, staticRenderFns } from "./ProductListEdit.vue?vue&type=template&id=0895125a&scoped=true&"
import script from "./ProductListEdit.vue?vue&type=script&lang=js&"
export * from "./ProductListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0895125a",
  null
  
)

export default component.exports